import Vue from 'vue'
import Vuex from 'vuex'

import { scenarioModule } from './modules/scenario.module'
import { traineeStatusModule } from './modules/status.trainee.module'
import { modalModule } from './modules/modal.module'
import { notepadModule } from './modules/notepad.module'
import { chatModule } from './modules/chat.module'

import * as scenarioSearch from './modules/scenarioSearch.js'
import * as notification from '@/store/modules/notification.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseUrl: "https://prototype.sssponline.com",
    // baseUrl: "http://192.168.178.35:8080",
    scanned: false,
    headerComponent: 'PageHeader',
    headerTitle: 'Stadium & Security'
  },
  mutations: {
    setScanned (state, payload) {
      state.scanned = payload
    },
    setHeaderType (state, payload) {
      state.headerComponent = payload
    },
    setHeaderTitle (state, payload) {
      state.headerTitle = payload
    }
  },
  actions: {
    setScanned (context, payload) {
      context.commit('setScanned', payload)
    },
    setHeaderType (context, payload) {
      context.commit('setHeaderType', payload)
    },
    setHeaderTitle (context, payload) {
      context.commit('setHeaderTitle', payload)
    }
  },
  modules: {
    scenarioModule,
    traineeStatusModule,
    modalModule,
    notification,
    notepadModule,
    chatModule,
    scenarioSearch
  }
})
